module.exports = __webpack_public_path__ + "assets/images/match-field-sponsor-heineken-green.1200a8cd12d86d11fb7e2731e2ab5965.png";